import { render, staticRenderFns } from "./BandeiraRoute.vue?vue&type=template&id=047d4ec4"
import script from "./BandeiraRoute.vue?vue&type=script&lang=js"
export * from "./BandeiraRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports